import { httpGet } from '../../../../components/utils';
import { InsightReasonsResponse } from '../types/ShadowAdminInsightReason';
import { useEffect, useState } from 'react';
import { HttpResponse } from '../../../../api/types/Http';

const useGetShadowAdminReasons = (entityGuid: string, shouldFetch: boolean) => {
    const [data, setData] = useState<InsightReasonsResponse>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const getShadowAdminReasons = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet(
                    `/insights/shadowAdminReasons/${entityGuid}`
                )) as unknown as HttpResponse<InsightReasonsResponse>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get shadow admin reasons');
            }

            setIsFetching(false);
        };

        if (shouldFetch) {
            getShadowAdminReasons();
        }
    }, [entityGuid, shouldFetch]);

    return { data, isFetching, error };
};

export default useGetShadowAdminReasons;
